module.exports = __webpack_public_path__ + "media/images/icheck/aero_dam@0.5x-adfc4f91d681c55f030b51d8150b83b8.png";